import { AuthorizationConstants } from "../authorization.constants";
export class RuntimePermission {
    constructor(namespace, code, description) {
        this.namespace = namespace;
        this.code = code;
        this.description = description;
    }
    getKey() {
        return `${this.namespace}${AuthorizationConstants.DEFAULT_NAMESPACE_SEPARATOR}${this.code}`;
    }
    toString() {
        return this.getKey();
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicnVudGltZS1wZXJtaXNzaW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3NoYXJlZC9hdXRob3JpemF0aW9uL21vZGVscy9ydW50aW1lLXBlcm1pc3Npb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSUEsT0FBTyxFQUFDLHNCQUFzQixFQUFDLE1BQU0sNEJBQTRCLENBQUM7QUFFbEUsTUFBTSxPQUFPLGlCQUFpQjtJQUsxQixZQUNJLFNBQWlCLEVBQ2pCLElBQVksRUFDWixXQUFvQjtRQUVwQixJQUFJLENBQUMsU0FBUyxHQUFHLFNBQVMsQ0FBQztRQUMzQixJQUFJLENBQUMsSUFBSSxHQUFHLElBQUksQ0FBQztRQUNqQixJQUFJLENBQUMsV0FBVyxHQUFHLFdBQVcsQ0FBQztJQUNuQyxDQUFDO0lBRU0sTUFBTTtRQUNULE9BQU8sR0FBRyxJQUFJLENBQUMsU0FBUyxHQUFHLHNCQUFzQixDQUFDLDJCQUEyQixHQUFHLElBQUksQ0FBQyxJQUFJLEVBQUUsQ0FBQztJQUNoRyxDQUFDO0lBRU0sUUFBUTtRQUNYLE9BQU8sSUFBSSxDQUFDLE1BQU0sRUFBRSxDQUFDO0lBQ3pCLENBQUM7Q0FDSiJ9